import axios from "axios";

export default axios.create({
    baseURL:"https://api.hugsangbaan.com/"  
    // baseURL:"http://localhost:3001/"
})